import { KEN_LIVE_VERSION, CONNECTION_VERSION } from './version';

export const environment = {
  production: false,
  kenLiveVersion: KEN_LIVE_VERSION,
  connectionVersion: CONNECTION_VERSION,
  isHMIMode: false,
  useHashRouting: false,
  mapKey: 'AIzaSyDVNeaGF1_nIsO0CMjipG5oSKqbISR-iYQ',
  mapId: 'f534f9f21b1086648364dbb8',
  wsURL: 'wss://data.releasetotest.libertylift.com:3021',
  oktaOrigin: 'https://automation.libertylift.com',
  authOrigin:
    '/oauth2/default/v1/authorize?client_id=0oa1o5do2awtF3DTo358&response_type=token&scope=openid%20offline_access&redirect_uri=https://releasetotest.libertylift.com/&state=state-7f53e860-4c11-49ac-b0a2-a2b5e65f1ee4&nonce=g5ly497e8ps',
};
